import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentFeedbackLinkComponent } from './student-feedback-link/student-feedback-link.component';
import { StudentFeedbackReportComponent } from './student-feedback-report/student-feedback-report.component';

const routes: Routes = [
    {
                    path:'',component:StudentFeedbackLinkComponent,
                    children:[
                      {
                        path:"studentfeedback", component:StudentFeedbackReportComponent
                      },  
                    ]
                  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentFeedbackRoutingModule { }
